import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap'
import { FC, useState } from 'react'
import { Dialog } from 'primereact/dialog'
import { FileUpload } from 'primereact/fileupload'
import useAuth from '../../../../hooks/useAuth'
import { Link } from 'react-router-dom'
import DeleteDialog from '../../../common/dialogs/DeleteDialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    IconName,
    faCheck,
    faDownload,
    faFile,
} from '@fortawesome/free-solid-svg-icons'
// import { useAppSelector } from '../../../../store/hooks'

type MediaFile = {
    id: number
    file_name: string
    file_extension: string
    url: string
    preview_url?: string
}

interface MediaFilesDialogProps {
    moduleCode: string
    moduleId: number
    tempToken: string
    label: string
    buttonLabel?: string
    mediaFiles: MediaFile[]
    setMediaFiles?: any
}

const MediaFilesDialog: FC<MediaFilesDialogProps> = ({
    moduleCode,
    moduleId,
    tempToken,
    label,
    buttonLabel,
    mediaFiles,
    setMediaFiles,
}) => {
    // const theme = useAppSelector((state) => state.theme.theme)
    const [dialogVisible, setDialogVisible] = useState(false)

    const { auth }: any = useAuth()

    const footerContent = (
        <div>
            <Button
                variant={'success'}
                onClick={() => setDialogVisible(false)}
                className="p-button-text"
            >
                <FontAwesomeIcon icon={faCheck} className="me-1" /> Done
            </Button>
        </div>
    )

    return (
        <>
            <Form.Group>
                <Form.Label>Files &amp; Images</Form.Label>
                <InputGroup className="mb-3" size="sm">
                    <br />
                    <Form.Control
                        placeholder="Recipient's username"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                        readOnly
                        value={label}
                    />
                    <Button
                        variant="warning"
                        onClick={() => setDialogVisible(true)}
                    >
                        {buttonLabel || 'Edit'}
                    </Button>
                </InputGroup>
            </Form.Group>
            <Dialog
                header={
                    <span>
                        <FontAwesomeIcon icon={faFile} className="me-2" />{' '}
                        Manage files
                    </span>
                }
                visible={dialogVisible}
                breakpoints={{ '960px': '60vw', '640px': '80vw' }}
                style={{ width: '75vw' }}
                onHide={() => setDialogVisible(false)}
                footer={footerContent}
                maximizable={true}
                closable={false}
            >
                <Row>
                    <Col lg={4}>
                        {mediaFiles.length <= 0 && <h6>No files</h6>}
                        {mediaFiles.map((mediaFile: MediaFile) => (
                            <InputGroup
                                size="sm"
                                className="mb-1"
                                key={mediaFile.id}
                            >
                                <InputGroup.Text
                                    id="inputGroup-sizing-sm"
                                    style={{
                                        width: 42,
                                        height: 42,
                                        textAlign: 'center',
                                    }}
                                >
                                    {mediaFile.preview_url ? (
                                        <img
                                            alt={
                                                'file-' +
                                                moduleCode +
                                                '-' +
                                                moduleId +
                                                '-' +
                                                mediaFile.file_name
                                            }
                                            src={mediaFile.preview_url}
                                            className="w-100"
                                        />
                                    ) : (
                                        <FontAwesomeIcon
                                            icon={
                                                ('file-' +
                                                    mediaFile.file_extension) as IconName
                                            }
                                            className="me-2 w-100 px-2 fa-1.5x"
                                        />
                                    )}
                                </InputGroup.Text>
                                <Form.Control
                                    value={mediaFile.file_name}
                                    readOnly
                                />
                                <Link
                                    target="_blank"
                                    to={mediaFile.url}
                                    className="btn btn-outline-info"
                                >
                                    <FontAwesomeIcon icon={faDownload} />
                                </Link>

                                <DeleteDialog
                                    url={`/client-modules/media/delete/${
                                        mediaFile.id
                                    }/${moduleCode}${
                                        moduleId ? `/${moduleId}` : ''
                                    }${
                                        tempToken
                                            ? `?temp_token=${tempToken}`
                                            : ''
                                    }`}
                                    record={mediaFile}
                                    deletedCallback={(response) => {
                                        setMediaFiles(
                                            response.data.data.media_files
                                        )
                                    }}
                                    message={
                                        <>
                                            <p className="mb-3 pb-3 border-bottom">
                                                Are you sure you want to delete
                                                file:
                                                <strong>
                                                    {' '}
                                                    {mediaFile.file_name}
                                                </strong>
                                                ?
                                            </p>
                                        </>
                                    }
                                />
                            </InputGroup>
                        ))}
                    </Col>
                    <Col lg={8}>
                        <FileUpload
                            name="media_files[]"
                            url={`${
                                process.env.REACT_APP_API_ROOT_URL
                            }/client-modules/media/upload/${moduleCode}${
                                moduleId ? `/${moduleId}` : ''
                            }${tempToken ? `?temp_token=${tempToken}` : ''}`}
                            onBeforeSend={(e) => {
                                e.xhr.setRequestHeader(
                                    'authorization',
                                    `Bearer ${auth?.accessToken}`
                                )
                            }}
                            onUpload={(e) => {
                                const responseObject = JSON.parse(
                                    e.xhr.response
                                )

                                if (responseObject.success) {
                                    setMediaFiles(
                                        responseObject.data.media_files
                                    )
                                }
                            }}
                            multiple
                            accept="*"
                            maxFileSize={5000000}
                            emptyTemplate={
                                <p className="m-0">
                                    Drag and drop files to here to upload.
                                </p>
                            }
                        />
                    </Col>
                </Row>
            </Dialog>
        </>
    )
}

export default MediaFilesDialog
